import { useEffect } from 'react';

// Crisp live-chat widget. Loads the Crisp client script once and exposes the
// global $crisp queue. The Kanarix Crisp Website ID is used by default; override
// it at runtime by setting window.CRISP_WEBSITE_ID before this mounts.
// Configure greetings / predefined messages in the Crisp dashboard (no code).
const DEFAULT_CRISP_WEBSITE_ID = 'f6faf619-9285-4e2b-a5b4-a268056221d4';

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
  }
}

interface Props {
  /** Optionally pre-fill the visitor's email/name in Crisp (e.g. logged-in customer). */
  email?: string;
  name?: string;
}

export default function CrispChat({ email, name }: Props) {
  useEffect(() => {
    const websiteId = window.CRISP_WEBSITE_ID || DEFAULT_CRISP_WEBSITE_ID;
    if (!websiteId) return;

    if (!window.$crisp) {
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = websiteId;
      const s = document.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = true;
      document.head.appendChild(s);
    }
    return undefined;
  }, []);

  // Identify the visitor when we know who they are.
  useEffect(() => {
    if (!window.$crisp) return;
    if (email) window.$crisp.push(['set', 'user:email', [email]]);
    if (name) window.$crisp.push(['set', 'user:nickname', [name]]);
  }, [email, name]);

  return null;
}
